import config from"./";export const EnableAnimation=!config.e2eTesting;export default EnableAnimation;